/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useLinkStyles } from 'components/common/useLinkStyles';
import ContactForm from '../../components/addressBook/contact/ContactForm';
import AlertDialog from '../../components/common/alertDialog/AlertDialog';
import DuplicateContactDialog from '../../components/addressBook/duplicate/DuplicateContactDialog';
import ContactFooter from '../../components/addressBook/contact/ContactFooter';
import { OpenMode } from '../../components/addressBook/contact/openMode';
import useContactForm from '../../components/addressBook/contact/useContactForm';
import { PartyStatus } from '../../components/addressBook/PartyStatus';
import ConfirmDelete from '../../components/common/ConfirmDelete';
import { RoutePath } from '../../shared/enums/RoutePath';

export default function Contact() {
  const { t } = useTranslation();
  const linkClass = useLinkStyles();

  const history = useHistory();
  document.title = 'Contact - Address Book';

  const {
    contact,
    apiContact,
    showSuccessDialog,
    partyResult,
    setPartyResult,
    openMode,
    deleteDialog,
    setShowSuccessDialog,
    resolveAllDuplicates,
    onChange,
    onSave,
    onEdit,
    onDelete,
    uiSchemaAddressBook,
    validationSchemaAddressBook,
    isValid,
    onCancel,
    resultMessage,
  } = useContactForm();

  const onClose = () => {
    if (contact?.id && contact?.status === PartyStatus.CONFIRMED) {
      history.push(`/addressbook/contact/${contact.id}`);
    }
    setShowSuccessDialog(false);
    setPartyResult(null);
  };

  return (
    <>
      <div className="wideContainer">
        <Breadcrumbs aria-label="breadcrumb" className="breadcrumbs">
          <Link className={linkClass.link} to={RoutePath.ADDRESSBOOK_SEARCH.path}>
            {t('address-book.title')}
          </Link>
          <Typography color="textPrimary">{t('contact.title')}</Typography>
        </Breadcrumbs>
        <ConfirmDelete selection={[apiContact]} deleteDialog={deleteDialog} />
        {uiSchemaAddressBook && validationSchemaAddressBook && (
          <ContactForm
            openMode={openMode}
            contact={contact}
            onChange={onChange}
            onDelete={onDelete}
            uiSchema={uiSchemaAddressBook}
            jsonSchema={validationSchemaAddressBook}
          />
        )}

        <AlertDialog
          isOpen={showSuccessDialog}
          title={t('contact.title')}
          message={t(resultMessage)}
          confirmButtonMessage={t('actions.ok')}
          handleConfirmButton={onClose}
        />
        {partyResult?.status === PartyStatus.DUPLICATED && (
          <DuplicateContactDialog
            partyResult={partyResult}
            onAllDuplicatesResolved={resolveAllDuplicates}
            onCancelSave={onCancel}
          />
        )}
      </div>
      {openMode !== OpenMode.VIEW && (
        <ContactFooter
          openMode={openMode}
          contact={contact}
          disabled={!isValid}
          onSave={onSave}
          onEdit={onEdit}
          onCancel={onCancel}
        />
      )}
    </>
  );
}
